export default "__VITE_ASSET__tmfqGyen__"